<template>
    <base-side-bar
        ><div class="flex flex-col items-center justify-center w-full mx-10">
            <h2
                class="font-extrabold leading-9 text-center text-blue-600 text-xxxl sm:text-xl sm:leading-10"
            >
                Chiffres d'affaires prévisionnels
            </h2>
            <br />
            <div class="w-full">
                <wide-card>
                    <tag-group :tags="tags" @clicked="checkOfferType" />
                </wide-card>
                <offers
                    v-on:showNotification="showNotification"
                    ref="chiffreAffaires"
                    v-if="chiffreAffaire.type === 'CA Détails'"
                    :offersObject="chiffreAffaire.offersObject"
                >
                    <wide-card
                        title="Taux de réalisation et Taux d’évolution"
                        titleClass="text-center mb-2"
                    >
                        <base-number-input
                            :max="100"
                            label="Taux d’évolution (%)"
                            v-model="tauxEvolution"
                            :hasError="$v.tauxEvolution.$error"
                            :errorMessage="
                                errorMessage(
                                    'Taux d\'évolution',
                                    $v.tauxEvolution
                                )
                            "
                            @blur="$v.tauxEvolution.$touch()"
                        />
                        <base-number-input
                            :max="100"
                            label="Taux de réalisation (%)"
                            v-model="tauxRealisation"
                            :hasError="$v.tauxRealisation.$error"
                            :errorMessage="
                                errorMessage(
                                    'Taux d\'évolution',
                                    $v.tauxRealisation
                                )
                            "
                            @blur="$v.tauxRealisation.$touch()"
                        />
                    </wide-card>
                </offers>
                <wide-card v-if="chiffreAffaire.type === 'CA Total'">
                    <base-number-input
                        label="Total CA prévisionnel annuel (HT)"
                        :isCurrency="true"
                        v-model="chiffreAffaire.totalCAPrevisionnel"
                        :hasError="$v.chiffreAffaire.totalCAPrevisionnel.$error"
                        :errorMessage="
                            errorMessage(
                                'Total CA prévisionnel (HT)',
                                $v.chiffreAffaire.totalCAPrevisionnel
                            )
                        "
                        @blur="$v.chiffreAffaire.totalCAPrevisionnel.$touch()"
                    />
                    <div
                        v-if="!isSimplifiedVersion"
                        class="flex items-center mt-8"
                    >
                        <h5 class="mr-4">Export</h5>
                        <toggle
                            class="mr-6"
                            v-on:toggleTriggered="checkExport"
                            :triggered="totalExport"
                        />
                    </div>
                    <base-number-input
                        :max="100"
                        v-if="totalExport"
                        label="Pourcentage vente à l’export"
                        v-model="tauxExport"
                    />

                    <base-number-input
                        :max="100"
                        label="Taux d’évolution"
                        v-model="chiffreAffaire.tauxEvolution"
                        :hasError="$v.chiffreAffaire.tauxEvolution.$error"
                        :errorMessage="
                            errorMessage('', $v.chiffreAffaire.tauxEvolution)
                        "
                        @blur="$v.chiffreAffaire.tauxEvolution.$touch()"
                    />
                    <base-number-input
                        :max="100"
                        label="Taux de réalisation (%)"
                        v-model="chiffreAffaire.tauxRealisation"
                        :hasError="$v.chiffreAffaire.tauxRealisation.$error"
                        :errorMessage="
                            errorMessage('', $v.chiffreAffaire.tauxRealisation)
                        "
                        @blur="$v.chiffreAffaire.tauxRealisation.$touch()"
                    />
                </wide-card>
                <wide-card
                    v-if="chiffreAffaire.type === 'CA Total' && totalExport"
                    title="CA à l’export"
                    titleClass="text-center mb-2"
                >
                    <h2
                        class="mr-6 text-sm font-extrabold leading-9 text-left text-blue-600 sm:text-lg sm:leading-10"
                    >
                        Total
                    </h2>
                    <div class="flex items-center w-full bg-gray-300">
                        <h2 class="p-2 text-lg font-extrabold leading-9">
                            {{
                                chiffreAffaire.totalCAPrevisionnel *
                                    (tauxExport / 100)
                            }}
                        </h2>
                    </div>
                </wide-card>
                <wide-card v-if="chiffreAffaire.type === 'CA Total'">
                    <label
                        class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                    >
                        L’estimation du CA prévisionnel a été faite en se basant
                        sur : :
                    </label>
                    <multiselect
                        v-model="chiffreAffaire.options"
                        tag-placeholder="Add this as new tag"
                        placeholder="Search or add a tag"
                        label="name"
                        track-by="code"
                        :options="options"
                        :multiple="true"
                        :taggable="false"
                        @tag="addTag"
                    ></multiselect>
                </wide-card>
            </div>
            <base-primary-button
                title="Suivant"
                @click="addchiffreAffaire"
            /></div
    ></base-side-bar>
</template>

<script>
import WideCard from "@/components/cards/wideCard";
import TagGroup from "@/components/forms/TagGroup";
import Offers from "./Chiffre_daffaire_previsionnel/offers";
import Toggle from "@/components/forms/Toggles/simpleToggle";
import { mapState, mapGetters } from "vuex";
import {
    minValue,
    required,
    decimal,
    maxValue
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: { WideCard, TagGroup, Offers, Toggle },

    mixins: [errorMessage, scrollToError],

    validations() {
        if (this.chiffreAffaire.type === "CA Total")
            return {
                chiffreAffaire: {
                    totalCAPrevisionnel: { minValue: minValue(0), required },
                    tauxEvolution: {
                        minValue: minValue(0),
                        maxValue: maxValue(100),
                        decimal,
                        required
                    },
                    tauxRealisation: {
                        minValue: minValue(0),
                        maxValue: maxValue(100),
                        decimal,
                        required
                    }
                }
            };
        else {
            return {
                tauxEvolution: { minValue: minValue(0), required },
                tauxRealisation: { minValue: minValue(0), required }
            };
        }
    },
    created() {
        this.$store.dispatch("forms/showSection", "Étude Financiere");
        this.$store.dispatch(
            "forms/stepFocus",
            "Chiffres d’affaires Prévisionnels"
        );
    },
    mounted() {
        this.chiffreAffaire = this.$store.getters[
            "EtudeFinanciere/getChiffreAffaire"
        ];

        this.tauxRealisation = this.$store.getters[
            "EtudeFinanciere/getChiffreAffaire"
        ].tauxRealisation;
        this.tauxEvolution = this.$store.getters[
            "EtudeFinanciere/getChiffreAffaire"
        ].tauxEvolution;

        this.tags.forEach(elem => {
            if (elem.value === this.chiffreAffaire.type) elem.isActive = true;
        });
    },
    data() {
        return {
            chiffreAffaire: {},
            tags: [
                { name: "CA Total", value: "CA Total", isActive: false },
                { name: "CA Détails", value: "CA Détails", isActive: false }
            ],
            value: [
                {
                    name:
                        "Le CA des concurrents et les statistiques du secteur",
                    code: "1"
                }
            ],
            totalExport: false,
            tauxRealisation: null,
            tauxEvolution: null,
            tauxExport: null
        };
    },
    computed: {
        ...mapGetters("user", {
            isSimplifiedVersion: "isSimplifiedVersion"
        }),
        ...mapState("forms", {
            options: state => state.ChiffresDaffairesPrevisionnels.options
        }),
        ...mapState("EtudeFinanciere", {
            chiffreAffaireLength: state => {
                return state.caDetails.offersObject.length;
            }
        })
    },
    methods: {
        checkOfferType(e) {
            this.chiffreAffaire.type = e;
        },
        checkExport(payload) {
            this.totalExport = payload;
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code:
                    newTag.substring(0, 2) +
                    Math.floor(Math.random() * 10000000)
            };
            this.options.push(tag);
            this.value.push(tag);
        },
        addchiffreAffaire() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                if (this.chiffreAffaire.type === "CA Total") {
                    this.$store.dispatch("EtudeFinanciere/addchiffreAffaire", {
                        type: "CA Total",
                        totalCAPrevisionnel: this.chiffreAffaire
                            .totalCAPrevisionnel,
                        tauxEvolution: this.chiffreAffaire.tauxEvolution,
                        tauxRealisation: this.chiffreAffaire.tauxRealisation,
                        tauxExport: this.tauxExport,
                        options: this.chiffreAffaire.options
                    });
                    this.$store.dispatch("EtudeFinanciere/SaveCaDetails");
                    this.$store.dispatch(
                        "forms/subStepComplete",
                        "Chiffres d’affaires Prévisionnels"
                    );
                    if (this.isSimplifiedVersion) {
                        this.$router.push({ name: "Charges_previsionnels" });
                    } else {
                        this.$router.push({ name: "achats_previsionnels" });
                    }
                } else {
                    if (
                        !this.$refs.chiffreAffaires.checkForms() &&
                        this.chiffreAffaireLength >= 1
                    ) {
                        this.$store.dispatch(
                            "EtudeFinanciere/addEvolutionToChiffre",
                            {
                                tauxEvolution: this.tauxEvolution,
                                tauxRealisation: this.tauxRealisation
                            }
                        );
                        this.$store.dispatch("EtudeFinanciere/SaveCaDetails");
                        this.$store.dispatch(
                            "forms/subStepComplete",
                            "Chiffres d’affaires Prévisionnels"
                        );
                        if (this.isSimplifiedVersion) {
                            this.$router.push({
                                name: "Charges_previsionnels"
                            });
                        } else {
                            this.$router.push({ name: "achats_previsionnels" });
                        }
                    } else {
                        this.showNotification();
                    }
                }
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        showNotification() {
            this.$emit("showNotification", {
                error: true,
                content:
                    "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                title: "Attention"
            });
        }
    }
};
</script>
<style></style>
